import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const CuentasBancariasKPIs = () => {
    return (
        <Row className="mb-4 g-2">
            <Col sm={12} lg={4}>
                <Card className="h-100 shadow-sm border-0 bg-white">
                    <Card.Body className="p-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <span className="text-muted mb-0 fw-bold" style={{ fontSize: '0.75rem' }}>SALDO TOTAL (MXN)</span>
                            <div className="bg-primary bg-opacity-10 text-primary rounded px-2 py-1" style={{ fontSize: '0.85rem' }}>
                                <FontAwesomeIcon icon="landmark" />
                            </div>
                        </div>
                        <h5 className="fw-bold text-dark mb-1">
                            $1,245,670.00
                        </h5>
                        <div className="text-muted d-flex align-items-center" style={{ fontSize: '0.75rem' }}>
                            En 5 cuentas activas
                        </div>
                    </Card.Body>
                </Card>
            </Col>
            <Col sm={6} lg={4}>
                <Card className="h-100 shadow-sm border-0 bg-white">
                    <Card.Body className="p-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <span className="text-muted mb-0 fw-bold" style={{ fontSize: '0.75rem' }}>SALDO EN DÓLARES (USD)</span>
                            <div className="bg-success bg-opacity-10 text-success rounded px-2 py-1" style={{ fontSize: '0.85rem' }}>
                                <FontAwesomeIcon icon="dollar-sign" />
                            </div>
                        </div>
                        <h5 className="fw-bold text-dark mb-1">
                            $45,300.00
                        </h5>
                        <div className="text-muted d-flex align-items-center" style={{ fontSize: '0.75rem' }}>
                            TC estimado: $18.50
                        </div>
                    </Card.Body>
                </Card>
            </Col>
            <Col sm={6} lg={4}>
                <Card className="h-100 shadow-sm border-0 bg-white border-start border-warning border-3">
                    <Card.Body className="p-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <span className="text-muted mb-0 fw-bold" style={{ fontSize: '0.75rem' }}>MOV. SIN CONCILIAR</span>
                            <div className="bg-warning bg-opacity-10 text-warning rounded px-2 py-1" style={{ fontSize: '0.85rem' }}>
                                <FontAwesomeIcon icon="triangle-exclamation" />
                            </div>
                        </div>
                        <h5 className="fw-bold text-dark mb-1">
                            24 <span className="text-muted ms-1 fw-normal" style={{ fontSize: '0.75rem' }}>movs globales</span>
                        </h5>
                        <div className="text-warning d-flex align-items-center fw-medium text-dark" style={{ fontSize: '0.75rem' }}>
                            Requiere tu atención
                        </div>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};
